export const getCookieObject = () =>
  document.cookie
    .split(";")
    .map((pair) => ({
      [pair.split("=")[0].trim()]: pair.split("=").slice(1).join("=").trim(),
    }))
    .reduce((acc, cur) => Object.assign(acc, cur), {});
